export const VIRTUA = "1230";


// WEBPACK FOOTER //
// ./src/components/constants/Accounts.js